import { Box, lighten } from "@mui/material";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { FormattedDate } from "utils/DateUtils";
import { WaterLevel } from "types/index";
import Marker from "./Marker";
import { DataFormat } from "imports/Utils";

const WaterlevelMarker = ({ level, onClick }: {
	level: WaterLevel;
	onClick: () => void;
}) => {

	const calculateWaterLevelHeight = () => {
		const percentage = 100 / (800 / level.waterLevelCm);
		const onePixel = 26 / 100;
		const height = percentage * onePixel;
		return height > 26 ? 26 : height;
	};

	const height = calculateWaterLevelHeight();

	return (
		<Marker
			color="#0f5e9c"
			content={(
				<Box
					sx={{
						borderRadius: "30px",
						height: 26,
						overflow: "hidden",
						position: "relative",
						width: 26,
					}}>
					<Box
						sx={{
							background: lighten("#0f5e9c", 0.2),
							bottom: 0,
							height: height,
							left: 0,
							position: "absolute",
							width: 26,
							zIndex: 2,
						}} />
					<Box
						sx={{
							position: "relative",
							zIndex: 3,
						}}>
						<ShowChartIcon />
					</Box>

				</Box>
			)}
			onClick={onClick}
			label={(
				<Box>
					<Box>{level.name}</Box>
					<Box>{DataFormat.simpleUnit(level.waterLevelCm, DataFormat.UNITS.CENTIMETER)}</Box>
					<Box><FormattedDate date={level.timestamp} /></Box>
				</Box>
			)}
			showLabelOnHover />
	);
};

export default WaterlevelMarker;
